import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import BaseComponent from "../../../gd-components/base-component/base-component";

import Classes from 'classnames';

export default class FormTextArea extends BaseComponent {
    static propTypes = {
        form: PropTypes.object, //.isRequired,
        name: PropTypes.string, //.isRequired,
        placeholder: PropTypes.string,

        value: PropTypes.string, // if no form

        rows: PropTypes.number,
        cols: PropTypes.number,

        size: PropTypes.oneOf(['big','normal','2-rows']),
        onClick: PropTypes.func,

        autosize: PropTypes.bool,           // if true the height will "fit" to the content making the component grow in height
        noResizeControl: PropTypes.bool            // no resize control
    };

    static defaultProps = {
        rows: 4,
        cols: 50,
        size: 'normal',
        autosize: false,
        noResizeControl: false
    };

    constructor(props) {
        super(props);

        if (this.props.form) this.props.form.registerFormComponent(this.props.name,this);
    }

    componentDidMount() {
        if (this.props.autosize) this.autoSizeHeight();
    }

    autoSizeHeight = () => {

        const textField = ReactDOM.findDOMNode(this);

        if (textField.clientHeight < textField.scrollHeight)
        {
            textField.style.height = textField.scrollHeight + "px";
            if (textField.clientHeight < textField.scrollHeight)
            {
                textField.style.height =
                    (textField.scrollHeight * 2 - textField.clientHeight) + "px";
            }
        }
    };

    _update = (newValue) => {
        if (this.props.form) {
            this.props.form.onFormComponentValueChange(this.props.name,newValue);
        }

        if (this.props.autosize) this.autoSizeHeight();

        this.forceUpdate(); // we need to re-render the field because it's BASIC control
    }

    insert = (value) => {
        const contentLength = this.textarea.value.length;
        this.textarea.focus();
        this.textarea.value =
            this.textarea.value.substr(0, this.textarea.selectionStart) +
            value +
            this.textarea.value.substring(this.textarea.selectionStart, contentLength);

        this._update(this.textarea.value);
    }

    onClick = () => {
        if (this.props.onClick) {
            this.props.onClick.call();
        }
    };

    onChange = (event) => {
        const newValue = event.target.value;
        this._update(newValue);
    };

    render() {
        let value = '';

        if (this.props.form) value = this.props.form.getValue(this.props.name);
        else value = this.props.value;

        const classes = Classes('gd-textarea', 'size-'+this.props.size, this.props.className, {
            'auto-size': this.props.autosize,
            'no-resize': this.props.noResizeControl
        });

        // fux null value to '' otherwise React warning
        if (!value) value = '';

        return (
            <textarea ref={r=>this.textarea = r}
                      className={classes}
                      rows={this.props.rows}
                      cols={this.props.cols}
                      value={value}
                      placeholder={this.props.placeholder}
                      onChange={this.onChange}
                      onClick={this.onClick}/>
        );
    }
}